import type React from "react";
import { Box, Text } from "@salestrak/ui";
import { SalesTrakLogo } from "#app/components/brand/salestrak-logo";

function UserEmailBadge({ email }: { email: string | null }) {
  if (!email) return null;
  return (
    <Box direction="column" align="end" paddingX="sm" paddingY="sm">
      <Text size="xs" variant="muted">
        Logged in as
      </Text>
      <Text size="sm" weight="medium">
        {email}
      </Text>
    </Box>
  );
}

type WorkspaceScreenLayoutProps = {
  email: string | null;
  children: React.ReactNode;
};

export function WorkspaceScreenLayout({
  email,
  children,
}: WorkspaceScreenLayoutProps) {
  return (
    <Box fill="flex" direction="column">
      <Box
        direction="row"
        align="start"
        justify="between"
        paddingX="lg"
        paddingY="lg"
      >
        <Box padding="xs">
          <SalesTrakLogo />
        </Box>
        <UserEmailBadge email={email} />
      </Box>

      {/* Plain functional overflow — no visible scrollbar chrome is wanted
          here, so this stays a Box rather than a ScrollArea (04 §13). */}
      <Box direction="column" flex={1} overflow="auto">
        <Box
          direction="column"
          fill="width"
          grow
          align="center"
          justify="center"
          paddingX="xl"
        >
          <Box fill="width" maxWidth={500} paddingBottom="xl">
            {children}
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
